import { Injectable } from '@angular/core';
import { includes, isNil } from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { filter, map, mergeMap, tap } from 'rxjs/operators';
import { UserService } from '../api/user.service';
import { AuthService } from '../auth.service';

@Injectable({
  providedIn: 'root',
})
export class UserStoreService {
  private readonly userStore = new BehaviorSubject([]);
  private readonly permissionStore = new BehaviorSubject([]);

  public user$ = this.userStore.pipe(
    mergeMap((users: any[]) => users),
    map((user: any) => user),
  );
  public roles$ = this.user$.pipe(map((user: any) => user.role));
  public permissions$ = this.permissionStore.asObservable();

  constructor(
    private userService: UserService,
    private authService: AuthService,
  ) {
    this.getUserByGuid(this.authService.currentUser.guid).subscribe();
    this.roles$
      .pipe(
        filter((roles) => !isNil(roles)),
        mergeMap((user: any) => this.userService.getUserPermissionByRoleGuid(user.guid)),
      )
      .subscribe((user: any) => this.permissionStore.next(user));
  }

  public getUserByGuid = (guid: string) => this.userService.getUserByGuid(guid).pipe(tap((user: any) => this.userStore.next(user)));

  public hasPermission = (permissionCode: string) =>
    includes(
      this.permissionStore.getValue().map((user: any) => user.code),
      permissionCode,
    );
}
